import request from "@/service";

//调查列表
export function getInvestigationList(params) {
  return request({
    url: `/study/investigation/page`,
    method: "get",
    params
  });
}

//调查列表by班级
export function getInvestigationPageByClass(params) {
  return request({
    url: `/study/investigation/pageForClass`,
    method: "get",
    params
  });
}

/* 调查新增 */
export function saveInvestigation(params) {
  return request({
    url: `/study/investigation/save`,
    method: "post",
    data: params
  });
}

/* 调查详情 */
export function getInvestigationInfo(uuid) {
  return request({
    url: `/study/investigation/info/${uuid}`,
    method: "get"
  });
}

/* 调查修改 */
export function updateInvestigation(params) {
  return request({
    url: `/study/investigation/update`,
    method: "put",
    data: params
  });
}

/* 调查删除 */
export function deleteInvestigation(params) {
  return request({
    url: `/study/investigation/delete`,
    method: "delete",
    data: params
  });
}

/* 发布/取消发布 */
export function publishInvestigation(uuid, status) {
  return request({
    url: `/study/investigation/publish/${uuid}/${status}`,
    method: "get"
  });
}

//列表
export function investigationUserPage(params) {
  return request({
    url: `/study/iu/page`,
    method: "get",
    params
  });
}

/* 删除用户 */
export function delInvestigationUser(data) {
  return request({
    url: "/study/iu/delete",
    method: "delete",
    data
  });
}

/* 新增调查用户 */
export function investigationUserSave(data) {
  return request({
    url: "/study/iu/save",
    method: "post",
    data
  });
}

/* 新增调查用户 */
export function getInvesResult(investId, userId) {
  return request({
    url: `/study/iu/answer/${investId}/${userId}`,
    method: "get"
  });
}

/* 导入调查用户 */
export function importInvestUser(params) {
  return request({
    url: `/study/iu/import`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

//结果统计分页
export function getResultPage(params) {
  return request({
    url: `/study/investigation/pageStatistics`,
    method: "get",
    params
  });
}

//结果统计详情
export function getOptionStatistics(params) {
  return request({
    url: `/study/investigation/getOptionStatistics/${params}`,
    method: "get"
  });
}

//结果统计详情
export function getPageOptionStatistics(params) {
  return request({
    url: `/study/investigation/pageOptionStatistics`,
    method: "get",
    params
  });
}
